var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"locked-item-component",on:{"click":_vm.checkPrivilidge}},[_vm._t("title"),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.locked && !_vm.isLogin),expression:"locked && !isLogin"}],staticClass:"lock-icon"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2b2305f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/common/lockedItem.vue
// module id = p6Cd
// module chunks = 1